var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input-password-base',{staticClass:"input-password",on:{"input":_vm.inputEvent}})
}
var staticRenderFns = []

export { render, staticRenderFns }